import { useForm, Controller } from "react-hook-form";
import { Form, Input, Button, message } from "antd";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { loginRequest } from "../../api/requests/auth";
import ForwardRefInput from "../common/ForwardRefInput";

const loginSchemaResolver = yupResolver(
  yup.object().shape({
    password: yup.string().required("No password provided."),
    // .min(8, "Password is too short - should be 8 chars minimum."),
  }),
);

const LoginForm = () => {
  const navigate = useNavigate();

  const { mutateAsync: login } = useMutation({
    mutationFn: async (data) => {
      const res = await loginRequest(data);
      return res.data;
    },
    onSuccess: (res) => {
      const authToken = res?.data?.token;
      if (authToken) {
        localStorage.setItem("authToken", authToken);
        navigate("/", { replace: true });
        // const otpVerified = res?.data?.user?.otp_verified;
        // if (otpVerified) {
        //   navigate("/", { replace: true });
        // } else {
        //   navigate("/auth/verify-otp");
        // }
      }
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.message || error.message;
      message.error(errorMessage);
    },
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: loginSchemaResolver,
  });

  async function onSubmit(data) {
    // console.log(data); // Handle form submission
    const res = await login(data);
    // console.log("res----->", res);
  }

  return (
    <div className="flex w-full flex-col justify-center px-20">
      <h2 className="mb-5 text-3xl font-bold">Login</h2>
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <Form.Item
          label="Username"
          name="username"
          validateStatus={errors.username ? "error" : ""}
          help={errors.username && errors.username.message}
        >
          <Controller
            control={control}
            name="username"
            render={({ field }) => (
              <Input
                {...field}
                placeholder="username"
                autoComplete="username"
              />
            )}
          />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          validateStatus={errors.password ? "error" : ""}
          help={errors.password && errors.password.message}
        >
          <Controller
            control={control}
            name="password"
            render={({ field }) => (
              <Input.Password
                {...field}
                placeholder="password"
                autoComplete="current-password"
              />
            )}
          />
        </Form.Item>

        {/* <div className="flex justify-end">
          <Link to="/auth/forget-password">Forgot Password?</Link>
        </div> */}

        <Button
          type="primary"
          htmlType="submit"
          className="mt-5 flex w-full items-center justify-center"
          size="large"
        >
          Log In
        </Button>

        {/* <div className="flex items-center gap-1.5 mt-3">
          <p className="m-0">Not registered Yet?</p>
          <Link to="/auth/register">Create account</Link>
        </div> */}
      </Form>
    </div>
  );
};

export default LoginForm;
